import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
    name: string;
    isNameProvided: boolean;
}

const initialState: UserState = {
    name: "",
    isNameProvided: false,
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUserName: (state, action: PayloadAction<string>) => {
            state.name = action.payload;
            state.isNameProvided = true;
        },
        clearUserName: (state) => {
            state.name = "";
            state.isNameProvided = false;
        },
    },
});

export const { setUserName, clearUserName } = userSlice.actions;
export default userSlice.reducer;
